import { Subject, debounceTime } from 'rxjs';
import { CoordinatorService } from './coordinator.service';
import { Filter } from './filter';

export class ScriptFilter {
    #coords: CoordinatorService;
    #filter: Filter;

    private _mFC$ = new Subject<void>();
    private _markForCheck$ = this._mFC$.pipe(debounceTime(200));

    constructor(coords: CoordinatorService, filter: Filter) {
        this.#coords = coords;
        this.#filter = filter;

        this._markForCheck$.subscribe(() => {
            this.#filter.run();
            this.#coords.filter$.run();
        });
    }

    require(ls: string | string[]) {
        if (!Array.isArray(ls)) {
            ls = [ls];
        }

        ls.forEach((v) => {
            this.#filter.setState(v.trim(), false);
        });
        this._mFC$.next();
        return this;
    }

    exclude(ls: string | string[]) {
        if (!Array.isArray(ls)) {
            ls = [ls];
        }

        ls.forEach((v) => {
            this.#filter.setState(v.trim(), true);
        });
        this._mFC$.next();
        return this;
    }

    clear(value: string) {
        value = value.trim();
        this.#filter.clearState(value);
        this._mFC$.next();
        return this;
    }

    reset() {
        this.#filter.clear();
        this._mFC$.next();
        return this;
    }
}
